import {
    getSVGIcon,
    setFilledStatus,
    handlePostalCodeInputRules,
    appendPostalOnFocus,
    setDynamicHeight
} from "../utilities/globalUtilities";
import { MAP_MARKER_COLOR, MAP_DARK_MARKER_COLOR, MAP_LABEL_COLOR, MAP_LABEL_FONT_SIZE, GTM_HOME, GTM_CG, MAP_AUTH_FAILED_CLASS } from "../utilities/constants";
import { appendError, getMap, getStoreMarker, mapMarkerIcon, initPostalCodeInputButtons } from "./coverageAreaUtil";

const googleMap = require("./googleMap");
import { inputAnimationEvents } from "../components/formElementsUtil";
import { initTooltip } from "../components/toolTip";

const cartUtil = require("./cartUtil");
const debounce = require("lodash/debounce");
const regex = require("../utilities/regex");
const scrollLock = require("../utilities/scrollLock");
const mqueryRespond = window.mqRespond;
const scrollThreshold = 25;
let customerCoordinates = {};
let searchCoordinates = {};
let selectedDeliveryPoint;
let skipCoverageAreaModal = false;
let storeToShow;

const $cache = {
    document: $(document),
    body: $("body"),
    coverageAreaModal: $("#coverage-area-modal")
};

cartUtil.init();

/**
 * @function
 * @description - Sets dynamically the height for the stores sections based on the remaining available viewport area
 * after the visible adjacent elements heights are substracted from the viewport height
 */
const setStoresSectionHeight = () => {
    if (mqueryRespond.status.mobile) {
        setDynamicHeight(
            document.querySelector(".delivery-nearest"),
            document.querySelectorAll("#coverage-area-modal :is(.modal-header, coverage-area-form, .delivery-home, .store-details.pwc-form-radio, .separator-container, .get-map"),
            70
        );
    }
};

/**
 * @function
 * @description - Retrieves content for the Delivery area modal
 */
const loadCoverageAreaModal = () => {
    $cache.document.on("click", "button.coverage-area-postal, .navigation-delivery-mobile", e => {
        e.preventDefault();

        let $this = $(e.currentTarget);
        cartUtil.updateCartSummaryModalClass(true);

        $.ajax({
            url: $this.data("url"),
            type: "GET",
            success: response => {
                $(".coverage-area-modal-body").replaceWith(response);
                initTooltip("#coverage-area-modal");
                initPostalCodeInputButtons("#coverage-area-modal");
                setFilledStatus();
                googlemapInitialized();
                inputAnimationEvents();
                $cache.document.trigger("initFormValidation");
                $.applyDataMask($("#coverage-area-modal").find("[data-mask]"));
                handlePostalCodeInputRules();
                appendPostalOnFocus($("#coverage-postal-code"));
                setStoresSectionHeight();

                $.when(googleMap.mapInit()).done(() => {
                    const hasDeliverySelected = $("#delivery-area").find(".pwc-form-check-input:checked").length > 0;
                    let deliveryLocation = $("#coverage-postal-code").val();

                    if (hasDeliverySelected && !deliveryLocation) { $("#coverage-area-modal .coverage-area-form").trigger("submit", [{loadStoresOnly: true}]); }
                }).fail(error => {
                    console.log("Error fetching Google Maps script: ", error);
                });
            }
        });
    });
};

/**
 * @function
 * @description - Retrieves postal code of customer current position
 */
const getPostalReverse = () => {
    $cache.document.on("click", ".postal-code-get-coordinates", () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                customerCoordinates.latitude = position.coords.latitude;
                customerCoordinates.longitude = position.coords.longitude;

                let google = window.google;
                let geocoder = new google.maps.Geocoder;
                let latlng = { lat: parseFloat(customerCoordinates.latitude), lng: parseFloat(customerCoordinates.longitude) };

                if ($(`.${MAP_AUTH_FAILED_CLASS}`).length) {
                    appendError(".js-coverage-area-error", "data-error-auth-failed");
                    return;
                }

                geocoder.geocode({ "location": latlng }, (results, status) => {
                    if (status === "OK") {
                        if (results.length > 0) {
                            let postalDetected = false;
                            for (let i = 0; i < results.length; i++) {
                                let result = results[i];

                                if (result.types.indexOf("postal_code") !== -1) {
                                    let postalCode = result.address_components[0].long_name;

                                    if (postalCode && postalCode.length == 4) {
                                        postalCode = postalCode.padEnd(8, "-000");
                                    }

                                    postalDetected = true;
                                    $("#coverage-postal-code").val(postalCode).addClass("filled");
                                    document.querySelectorAll(".postal-code-btn").forEach(btn => btn.classList.remove("d-none"));
                                    break;
                                }
                            }
                            if (!postalDetected) {
                                appendError(".coverage-area-error", "data-error-general");
                            }
                        } else {
                            appendError(".coverage-area-error", "data-error-nostores");
                        }
                    } else {
                        appendError(".coverage-area-error", "data-error-general");
                    }
                });
            }, () => appendError(".coverage-area-error", "data-error-allowgeo"));
        } else {
            appendError(".coverage-area-error", "data-error-apigeo");
        }
    });
};

/**
 * @function
 * @description - Tries to find a nearby store using the provided postal code
 */
const findStoreByPostalCode = () => {
    $cache.coverageAreaModal.off("submit", ".coverage-area-form").on("submit", ".coverage-area-form", (e, data) => {
        e.preventDefault();

        $cache.coverageAreaModal.find("#coverage-postal-code").trigger("blur");
        $cache.coverageAreaModal.find(".modal-footer button").prop("disabled", true);

        const loadStoresOnlyParam = data?.loadStoresOnly || false;
        const $storesOnlyContainer =  $(".js-coverage-area-stores-container");
        const typeAddress = {
            locality: "locality",
            administrative_area_level_2: "administrative_area_level_2",
            country: "country"
        };

        let $this = $(e.currentTarget);
        let deliveryLocation = $this.find(".postal-code").val();

        if (deliveryLocation && deliveryLocation.length == 4 && regex.values.digits.test(deliveryLocation)) {
            deliveryLocation = deliveryLocation.padEnd(8, "-000");
            $this.find(".postal-code").val(deliveryLocation);
        } else if (loadStoresOnlyParam)  {
            deliveryLocation = $(".coverage-modal-body").find("input:checked").not("[id*='store-postal']").val();
        }

        let google = window.google;

        if ($(`.${MAP_AUTH_FAILED_CLASS}`).length) {
            appendError(".js-coverage-area-error", "data-error-auth-failed");
            return;
        }

        if (!deliveryLocation || (regex.values.digits.test(deliveryLocation) && !regex.values.coverageAreaPostalCode.test(deliveryLocation))) {
            appendError(".coverage-area-error", "data-error-postalcode");
            return;
        }

        let url = loadStoresOnlyParam ? $storesOnlyContainer.attr("data-url") : $(e.target).attr("action");

        let geocoder = new google.maps.Geocoder();
        geocoder.geocode({"address": deliveryLocation, "componentRestrictions": {"country": "PT"}}, (results, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
                if (results[0].geometry.location.lat() && results[0].geometry.location.lng()) {
                    let deliveryPostalCode = "";
                    let city = "";
                    let result = results[0];

                    for (let i = 0; i < result.address_components.length; i++) {
                        let addressComponent = result.address_components[i];

                        for (let j = 0; j < addressComponent.types.length; j++) {
                            const componentAddress = addressComponent.types[j];

                            if (componentAddress === typeAddress.locality ||
                                (city === "" && componentAddress === typeAddress.administrative_area_level_2) ||
                                (city === "" && componentAddress === typeAddress.country)) {
                                city = addressComponent.long_name;
                            }
                        }

                        if (addressComponent.types.indexOf("postal_code") !== -1 && addressComponent.long_name && deliveryPostalCode == "") {
                            deliveryPostalCode = addressComponent.long_name;
                            if (deliveryPostalCode && deliveryPostalCode.length == 4 && regex.values.digits.test(deliveryPostalCode)) {
                                deliveryPostalCode = deliveryPostalCode.padEnd(8, "-000");
                            }
                        }
                    }

                    searchCoordinates.latitude = results[0].geometry.location.lat();
                    searchCoordinates.longitude = results[0].geometry.location.lng();

                    let params = {
                        deliveryLocation: deliveryLocation,
                        deliveryPostalCode: deliveryPostalCode,
                        city: city,
                        latitude: results[0].geometry.location.lat(),
                        longitude: results[0].geometry.location.lng(),
                        searchLatitude: results[0].geometry.location.lat(),
                        searchLongitude: results[0].geometry.location.lng()
                    };

                    if (loadStoresOnlyParam) {
                        $storesOnlyContainer.spinner().start();
                    }

                    $.ajax({
                        url: url,
                        type: "GET",
                        data: params,
                        success: response => {
                            const $deliveryArea = $(".delivery-area");
                            const $coverageSubtitleWrapper = $(".coverage-subtitle-wrapper");
                            const $separatorArea = $(".separator-area");
                            const $container = loadStoresOnlyParam ? $storesOnlyContainer : $deliveryArea;
                            const $searchCoordinatesContainer = $(".search-coordinates");

                            if (loadStoresOnlyParam && $searchCoordinatesContainer.length > 0) {
                                $searchCoordinatesContainer.attr("data-search-coordinates-latitude", searchCoordinates.latitude);
                                $searchCoordinatesContainer.attr("data-search-coordinates-longitude", searchCoordinates.longitude);
                            }

                            $container.html(response);

                            setStoresSectionHeight();
                            //calculate and add distances
                            setStoresDistance($(".delivery-nearest .store-distance"));

                            // if another location is inserted while the store map is displayed, update the store map with the new response
                            if ($this.closest(".coverage-modal-body").hasClass("coverage-modal-map")) {
                                const $newDeliveryPoints = $(".delivery-nearest");

                                if ($newDeliveryPoints.children().length) {
                                    const $firstStore = $newDeliveryPoints.find(".store-details").first().find(".store-marker");
                                    $firstStore.trigger("click");
                                }
                            } else {
                                $coverageSubtitleWrapper.addClass("d-none");
                                $separatorArea.addClass("no-text");
                                $deliveryArea.removeClass("d-none");
                            }
                        },
                        complete: () => {
                            if (loadStoresOnlyParam) {
                                $storesOnlyContainer.spinner().stop();
                            }
                        }
                    });
                }
            } else if (status == google.maps.GeocoderStatus.ZERO_RESULTS) {
                appendError(".coverage-area-error", "data-error-nostores");
            } else {
                appendError(".coverage-area-error", "data-error-general");
            }
        });
    });
};

/**
 * @function
 * @description - Asks for geolocation permission before rendering map.
 */
const showStoreDetails = () => {
    $cache.document.on("click", ".store-marker", e => {
        const coverageAreaPostalCode = document.getElementById("coverage-postal-code");
        const postalCodeValue = coverageAreaPostalCode.value;

        storeToShow = $(e.currentTarget);

        if (postalCodeValue) {
            let google = window.google;
            let geocoder = new google.maps.Geocoder();

            if ($(`.${MAP_AUTH_FAILED_CLASS}`).length) {
                appendError(".js-coverage-area-error", "data-error-general-short");
                return;
            }

            geocoder.geocode({"address": postalCodeValue, "componentRestrictions": {"country": "PT"}}, (results, status) => {
                if (status == google.maps.GeocoderStatus.OK) {
                    customerCoordinates.latitude = results[0].geometry.location.lat();
                    customerCoordinates.longitude = results[0].geometry.location.lng();

                    showStoresMap(storeToShow);
                } else if (status == google.maps.GeocoderStatus.ZERO_RESULTS) {
                    appendError(".js-coverage-area-error", "data-error-nostores");
                } else {
                    appendError(".js-coverage-area-error", "data-error-general");
                }
            });
        } else {
            navigator.geolocation.getCurrentPosition(onPositionAllow, onPositionDecline);
        }

    });
};

/**
 * @function
 * @description - Shows google map for selected store with customer position
 */
const onPositionAllow = (position) => {
    customerCoordinates.latitude = position.coords.latitude;
    customerCoordinates.longitude = position.coords.longitude;

    showStoresMap(storeToShow);
};

/**
 * @function
 * @description - Shows google map for selected store without customer position
 */
const onPositionDecline = () => {
    customerCoordinates.latitude = null;
    customerCoordinates.longitude = null;

    showStoresMap(storeToShow);
};

/**
 * @private
 * @function
 * @description - Starts the stores map
 * @param {Element} selectedStore - Selected store element
 */
const showStoresMap = selectedStore => {
    let storeMarker;
    let customerMarker;
    let google = window.google;
    let map = getMap("map-stores");
    let bounds = new google.maps.LatLngBounds();
    let stores = $(".delivery-nearest .store-details");

    const $coverageModalBody = $(".coverage-modal-body");
    const $primaryCoverageModalTitle = $(".coverage-modal-title.primary-title");
    const $secondaryCoverageModalTitle = $(".coverage-modal-title.secondary-title");

    $(".coverage-area-arrow-left").removeClass("d-none");
    $coverageModalBody.addClass("coverage-modal-map");
    $primaryCoverageModalTitle.addClass("d-none");
    $secondaryCoverageModalTitle.removeClass("d-none");
    selectedDeliveryPoint = selectedStore.closest("div.store-details");

    $(".delivery-area").addClass("d-none");
    let storeDetails = selectedStore.parent().data("storedetails");

    stores.each(function () {
        let storeWrapper = $(this);

        if (storeWrapper.data("delivery-latitude") != null && storeWrapper.data("delivery-longitude") != null) {
            if (storeWrapper.data("sid") != storeDetails.ID) {
                storeMarker = getStoreMarker(storeWrapper, map);
                bounds.extend(storeMarker.position);
            }
        }
    });

    // prepare marker for selected store
    let storePosition = {lat: Number(storeDetails.latitude), lng: Number(storeDetails.longitude)};
    let storeIndex = parseInt(selectedStore.parent().data("index"), 10).toString();

    let storeLocation = new google.maps.Marker({
        icon: mapMarkerIcon(MAP_DARK_MARKER_COLOR),
        label: {
            text: storeIndex,
            color: MAP_LABEL_COLOR,
            fontSize: MAP_LABEL_FONT_SIZE
        },
        position: storePosition,
        map: map,
        optimized: false,
        zIndex: 2
    });

    bounds.extend(storeLocation.position);

    // prepare customer current location
    if (customerCoordinates.latitude && customerCoordinates.longitude) {
        customerMarker = getCustomerMarker(map);
        bounds.extend(customerMarker.position);
    }

    map.fitBounds(bounds);

    $(".stores-map-area").removeClass("d-none");
    $(".store-info").empty().html(selectedStore.parent().find(".store-detailed-info").html());
    $(".store-info").removeClass("d-none");
    $(".coverage-modal-body").closest(".modal-dialog").addClass("coverage-area-modal");
};

/**
 * @private
 * @function
 * @description - Returns marker of customer current position
 * @param {Object} map - Map object
 */
const getCustomerMarker = map => {
    let google = window.google;
    let customerPosition = {lat: Number(customerCoordinates.latitude), lng: Number(customerCoordinates.longitude)};
    let customerLocation = new google.maps.Marker({
        icon: {
            path: google.maps.SymbolPath.CIRCLE,
            strokeColor: MAP_MARKER_COLOR,
            strokeWeight: 1,
            scale: 5
        },
        clickable: false,
        position: customerPosition,
        map: map,
        optimized: false
    });

    return customerLocation;
};

/**
 * @private
 * @function
 * @description - Gets nearest stores and calculates distance to selected delivery point
 * @param {Object} stores - Stores object
 */
const setStoresDistance = stores => {
    let searchPos = $(".search-coordinates");
    let searchLatitude = searchPos.attr("data-search-coordinates-latitude");
    let searchLongitude = searchPos.attr("data-search-coordinates-longitude");
    let google = window.google;
    let origin = new google.maps.LatLng(searchLatitude, searchLongitude);

    stores.each((index, element) => {
        let $store = $(element);
        let storeDetails = $store.closest("[data-storedetails]").data("storedetails");
        let distanceUnit = $store.data("distance-unit");
        let destination = new google.maps.LatLng(storeDetails.latitude, storeDetails.longitude);
        let distance = (google.maps.geometry.spherical.computeDistanceBetween(origin, destination) * 0.001).toFixed(2);
        $(".value-km", $store).text(parseInt(distance, 10) + distanceUnit + " " + $store.data("auxtext"));
    });
};

/**
 * @function
 * @description - Handles confirmation of selected delivery point.
 * Receives coverage area response and sets store context.
 */
const confirmAreaSelect = () => {

    $cache.coverageAreaModal.on("click", ".modal-footer button", () => {
        if ($cache.coverageAreaModal.hasClass("show")) {
            $("header .delivery-wrapper .delivery-options .options-selector .options-detail").trigger("click");
        }
    });

    $cache.document.on("click", "button.confirm-coverage-area-select:not(.open-modal-mobile)", () => {
        let productToAdd = cartUtil.getProductToAdd();
        let params;
        let $this = selectedDeliveryPoint;
        let selectedPostal = $this.data("postal");
        let selectedAddressId = $this.data("address-id");
        let selectedDeliveryLocation = $this.data("delivery-location");
        let selectedDeliveryLatitude = $this.data("delivery-latitude");
        let selectedDeliveryLongitude = $this.data("delivery-longitude");
        let selectedCity = $this.data("delivery-city");
        let selectedID = $this.data("sid");

        // call Stores-GetCoverageArea
        // receive feedback
        params = {postalCode: selectedPostal};
        $.ajax({
            url: $this.data("store-getcoverage"),
            type: "GET",
            data: params,
            beforeSend: $.spinner().start(),
            success: (response) => {
                if (!response.error) {
                    // call SetStoreContext (needs storeId and storeInfo)
                    params = {
                        storeId: response.data.storeId,
                        physicalStoreId: response.data.physicalStoreId,
                        areaID: response.data.areaID,
                        storeID: response.data.storeID,
                        storeInfo: selectedDeliveryLocation,
                        storePostalCode: selectedPostal,
                        latitude: selectedDeliveryLatitude,
                        longitude: selectedDeliveryLongitude,
                        searchLatitude: selectedDeliveryLatitude,
                        searchLongitude: selectedDeliveryLongitude,
                        city: selectedCity,
                        ID: selectedID,
                        selectedAddressId: selectedAddressId
                    };

                    $.post($this.data("store-setcontext"), params, (responseData) => {
                        if (!responseData.error) {
                            $(".store-context-info").first().html("true");

                            //GTM logic start
                            document.dispatchEvent(new CustomEvent("dataLayer.deliveryAreaEvents", {
                                detail: {
                                    "status": response.data.customerStatus,
                                    "action": "change address",
                                    "type": selectedID ? GTM_CG : GTM_HOME
                                }
                            }));
                            //GTM logic end

                            if (productToAdd) {
                                skipCoverageAreaModal = true;
                                $cache.coverageAreaModal.find(".modal-footer button").trigger("click");
                                $("button.coverage-area-postal span.delivery-location").html(selectedDeliveryLocation);

                                fillTheWrapper(params, responseData.resources, responseData.links);
                                cartUtil.resumeAddToCart(productToAdd);
                                $.spinner().stop();
                            } else {
                                location.reload();
                            }
                        } else {
                            $.spinner().stop();
                            appendError(".coverage-area-error", responseData.message);
                            $cache.coverageAreaModal.find(".modal-footer button").trigger("click");
                            $("header .delivery-wrapper .delivery-options .options-selector .options-detail").trigger("click");
                        }
                    });
                } else {
                    $.spinner().stop();
                    appendError(".coverage-area-error", response.message);
                    $cache.coverageAreaModal.find(".modal-footer button").trigger("click");
                    $("header .delivery-wrapper .delivery-options .options-selector .options-detail").trigger("click");
                }
            }
        });
    });

    $cache.document.on("click", "button.decline-coverage-area-select", () => {
        $cache.coverageAreaModal.find(".modal-footer button").prop("disabled", false).trigger("click");
        $("header .delivery-wrapper .delivery-options .options-selector .options-detail").trigger("click");
    });
};

/**
 * @function
 * @description - Fills the postal-code-input-wrapper with delivery data, after adding the product to the cart (mobile)
 * @param {Object} params - delivery data
 * @param {Object} resources - static text
 * @param {Object} links - links
 */
const fillTheWrapper = (params, resources, links) => {
    let postalWrapper;
    let postalWrapperData;

    if (params.storeInfo === params.storePostalCode) {
        //home delivery
        postalWrapperData = {
            svgDeliveryData : getSVGIcon("icon-home"),
            title : `<span class="hover-input-text js-postal-title-label">${resources.addressLabel}</span>`
        };
    } else {
        //click&go
        postalWrapperData = {
            svgDeliveryData : getSVGIcon("icon-clickgo-pin"),
            title : `<span class="hover-input-text js-postal-title-label">${resources.clickGoLabel} ${getSVGIcon("icon-clickgo")}`
        };
    }
    //postal wrapper
    postalWrapper = `
        <label for="coverage-postal-code" class="visually-hidden"></label>
        <button type="button" class="postal-code js-coverage-area-postal form-control pwc-form-input main-border text-left postal-code-selected" data-toggle="modal" data-target="#coverage-area-modal" data-url="${links.getDeliveryLink}">
            <span>
                ${params.storeInfo}
            </span>
        </button>

        <button class="postal-code-get-coordinates coverage-area-mobile-icon" type="submit" data-url="${links.findStoreLink}" data-store-context="${links.setStoreContextLink}">
            ${postalWrapperData.svgDeliveryData}
        </button>

        <button type="button" class="postal-code-edit coverage-area-mobile-icon d-flex align-items-center" id="mobile-coverage-postal-code">
            ${getSVGIcon("icon-edit")}
        </button>
        ${postalWrapperData.title}
    `;
    $("header .postal-code-input-wrapper").html(postalWrapper);
};

/**
 * @function
 * @description Handles click on the Cancel button on the confirmation modal.
 */
const declineAreaSelect = () => {
    $cache.document.on("hidden.bs.modal", "#confirm-coverage-area-modal", () => {
        $("#confirm-coverage-area-modal").modal("hide");
        cartUtil.updateCartSummaryModalClass(false);

        if (skipCoverageAreaModal === false) {
            $("#coverage-area-modal").modal("show");
            cartUtil.updateCartSummaryModalClass(true);
        }

        //uncheck a radio button if a delivery point wasn't confirmed
        let $checkmarks = $(".delivery-area .checkmark");
        $checkmarks.each(function () {
            let $clickedCheckmark = $(this).parent().find("input")[0];

            if ($clickedCheckmark.hasAttribute("checked") === true && $clickedCheckmark.checked === false) {
                $clickedCheckmark.checked = true;
            } else if ($clickedCheckmark.hasAttribute("checked") === false && $clickedCheckmark.checked === true) {
                $clickedCheckmark.checked = false;
            }
        });
    });

    $cache.document.on("shown.bs.modal", "#confirm-coverage-area-modal", debounce(() => {
        $cache.body.addClass("modal-open");
        cartUtil.updateCartSummaryModalClass(false);
        scrollLock.enable();
    }, 1));

    $cache.document.on("hide.bs.modal", "#coverage-area-modal", () => {
        const $targetBtn = document.querySelector(".js-coverage-area-postal");

        if ($targetBtn) {
            $targetBtn.disabled = true;
        }
    });

    $cache.document.on("hidden.bs.modal", "#coverage-area-modal", () => {
        const $targetBtn = document.querySelector(".js-coverage-area-postal");

        if ($targetBtn) {
            $targetBtn.disabled = false;
        }
    });
};

/**
 * @function
 * @description Handles click on a radio button in front of delivery address.
 * Saves selected element in order to use in confirmAreaSelect() function.
 */
const setStoreContext = () => {
    $cache.document.on("click", ".store-details input.pwc-form-check-input", e => {
        if (!$(e.target).closest("#shipping-new-store-modal").length) {
            e.stopPropagation();

            const $coverageAreaModalBody = $cache.coverageAreaModal.find(".coverage-modal-body");
            selectedDeliveryPoint = $(e.currentTarget).closest("div.store-details");

            if ($coverageAreaModalBody.hasClass("coverage-modal-map")) {
                storeToShow = selectedDeliveryPoint.find(".store-marker");
                navigator.geolocation.getCurrentPosition(onPositionAllow, onPositionDecline);
            } else {
                $cache.coverageAreaModal.find(".modal-footer button").removeAttr("disabled");
            }
        }
    });
};

/**
 * @function
 * @description Handles click on a radio button in front of delivery address.
 */
const setStoreContextOnMap = () => {
    $cache.document.on("click", "button.coverage-area-select", () => {
        $("#coverage-area-modal").modal("hide");
        cartUtil.updateCartSummaryModalClass(false);
    });
};

/**
 * @function
 * @description Calculates distance to stores once google map script loaded.
 */
const googlemapInitialized = () => {
    $cache.document.on("googlemap:initialized", () => {
        if ($(".search-coordinates").length) {
            setStoresDistance($(".delivery-nearest .store-distance"));
        }
    });
};

/**
 * @function
 * @description Handles click on back arrow on modal.
 */
const modalNavigation = () => {
    $cache.document.on("click", ".coverage-area-arrow-left", () => {
        const $coverageModalBody = $(".coverage-modal-body");
        const $primaryCoverageModalTitle = $(".coverage-modal-title.primary-title");
        const $secondaryCoverageModalTitle = $(".coverage-modal-title.secondary-title");

        $(".delivery-area").removeClass("d-none");
        $(".stores-map-area").addClass("d-none");
        $(".store-info").addClass("d-none");
        $(".coverage-area-arrow-left").addClass("d-none");
        $coverageModalBody.removeClass("coverage-modal-map").closest(".modal-dialog").removeClass("coverage-area-modal");
        $primaryCoverageModalTitle.removeClass("d-none");
        $secondaryCoverageModalTitle.addClass("d-none");
    });
};

/**
 * @function
 * @description Header coverage button tooltip
 */
const headerCoverageTooltip = () => {
    const $tooltip = $(".tooltip-delivery");
    const $tooltipCloseButton = $(".js-tooltip-close");
    var clicked = false;

    if (sessionStorage.getItem("tooltipMissoesClosed") === "true") {
        $tooltip.remove();
    } else {
        $tooltip.addClass("d-md-inline");
    }

    if ($tooltip && $tooltipCloseButton) {
        $tooltipCloseButton.on("click", () => {
            $tooltip.css("opacity", "0");
            $tooltip.css("z-index", "0");
            clicked = true;
            sessionStorage.setItem("tooltipMissoesClosed", "true");
        });

        window.onscroll = () => {
            if (!clicked) {
                if (document.documentElement.scrollTop > scrollThreshold) {
                    $tooltip.css("opacity", "0");
                    $tooltip.css("z-index", "0");
                } else {
                    $tooltip.css("opacity", "1");
                    $tooltip.css("z-index", "1");
                }
            }
        };
    }
};

/**
 * @function
 * @description Init
 */
const init = () => {
    loadCoverageAreaModal();
    findStoreByPostalCode();
    showStoreDetails();
    setStoreContext();
    setStoreContextOnMap();
    getPostalReverse();
    modalNavigation();
    confirmAreaSelect();
    declineAreaSelect();
    googlemapInitialized();
    headerCoverageTooltip();
};

export { init };
